import type {
  NetworkCategoryPerformance,
  NetworkProductRankingSelectionParams,
} from '@gozoki/api-types'

import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchNetworkCategoryPerformance = async (
  selection: NetworkProductRankingSelectionParams,
): Promise<NetworkCategoryPerformance> => {
  const params: Record<string, string> = {}
  if (selection.storeIds?.length) params.storeIds = selection.storeIds.join(',')
  if (selection.storeAgeFilter) params.storeAgeFilter = selection.storeAgeFilter
  if (selection.ageStoreIds !== undefined)
    params.ageStoreIds = selection.ageStoreIds.length ? selection.ageStoreIds.join(',') : ''
  if (selection.startDate) params.startDate = selection.startDate
  if (selection.endDate) params.endDate = selection.endDate
  if (selection.comparableStartDate) params.comparableStartDate = selection.comparableStartDate
  if (selection.comparableEndDate) params.comparableEndDate = selection.comparableEndDate
  if (selection.categoryIds?.length) params.categoryIds = selection.categoryIds.join(',')
  if (selection.indicator) params.indicator = selection.indicator

  const response = await gozokiApiWithAuth.get<NetworkCategoryPerformance>(
    '/stores/get-network-category-performance',
    { params: Object.keys(params).length ? params : undefined },
  )
  return response.data
}
